import React, { Component } from 'react';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import SocialMedia from '../../components/socialMedia/SocialMedia';
import Button from '../../components/button/Button';
import BlogsImg from './BlogsImg';
import AddressImg from './AddressImg';
import { Fade } from 'react-reveal';
import './ContactComponent.css';
import { greeting, contactPageData } from '../../portfolio.js';

const ContactData = contactPageData.contactSection;
const blogSection = contactPageData.blogSection;
const addressSection = contactPageData.addressSection;
const phoneSection = contactPageData.phoneSection;

class Contact extends Component {
	render() {
		const theme = this.props.theme;
		return (
			<div className="contact-main">
				<Header theme={theme} />
				<div className="basic-contact">
					<Fade bottom duration={1000} distance="40px">
						<div className="contact-heading-div">
							<div className="contact-heading-img-div">
								<img
									src="https://media-exp1.licdn.com/dms/image/C5603AQFd9vGWuPZo8Q/profile-displayphoto-shrink_200_200/0?e=1600300800&v=beta&t=prGiMA5fE19sMqWK9BxCZ8fS54q_Ek40LZkfqukebSM"
									alt=""
									class="my-photo"
								/>
							</div>
							<div className="contact-heading-text-div">
								<h1 className="contact-heading-text" style={{ color: theme.text }}>
									{ContactData["title"]}
								</h1>
								<p className="contact-header-detail-text subTitle" style={{ color: theme.secondaryText }}>
									{ContactData["description"]}
								</p>
								<SocialMedia />
							</div>
						</div>
					</Fade>
				</div>
				<Footer theme={this.props.theme} onToggle={this.props.onToggle} />
			</div>
		);
	}
}

export default Contact;